/**************************************************
 * Nombre:       Tarjeta_Documentos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import img_doc from '../../Recursos/ic_documento.svg'
import {descargarArchivo} from "../../Utilidades/descargarArchivo";

const Tarjeta_Documentos = ({item}) => {

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-end'}
            size={{xs: 12, sm: 12, md: 12}}
            spacing={0}
        >


            <Grid container size={{xs: 5, sm: 6, md: 6}} sx={{justifyContent: 'flex-start'}}>
                <img src={item.img ? item.img : img_doc} width={'90%'} height={'auto'}
                     style={{borderRadius: item.img ? 10 : 0}}
                />
            </Grid>


            <Grid container size={{xs: 7, sm: 6, md: 6}} sx={{justifyContent: 'flex-start'}}>
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', height: 40}}>
                        <Typography sx={{fontWeight: 600, lineHeight: 1.1}}>{item.nombre}</Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}}
                          sx={{justifyContent: 'flex-start', mt: 1, height: 86}}>
                        <Typography sx={{
                            fontSize: 12,
                            textOverflow: "ellipsis",
                            display: '-webkit-box',
                            overflow: 'hidden',
                            WebkitBoxOrient: 'vertical',
                            WebkitLineClamp: 5,

                        }}>
                            {item.descripcion}
                        </Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 2}}>
                        <Button
                            onClick={() => descargarArchivo(item.pdf, item.nombre + '.pdf')}
                            fullWidth sx={{fontSize: 12, borderRadius: 1}}>Descargar</Button>
                    </Grid>

                </Grid>
            </Grid>


        </Grid>
    )

}
export default Tarjeta_Documentos